import { datadogRum } from '@datadog/browser-rum'
import { getUserFacingRoleFromUserConfig, UserFacingRole } from '@omnea-app/fe-auth/roles'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { isProductionEnvironment } from '@omnea-app/fe-legacy/components/layout/wrapper/appUtils'

// Pylon's own login always sends users to the EU prod app, so each prod region signs its users in itself.
// Other stages can't sign a token Pylon accepts, so they keep Pylon's login.
const PYLON_LOGIN_URL = 'https://portal.usepylon.com/omnea/login?kbUrl=https://omnea-knowledge-base.help.usepylon.com/'
const SAME_REGION_PYLON_LOGIN_URL = '/api/auth/pylon-redirect'

const PYLON_ROLE_LABELS: Record<UserFacingRole, string> = {
  [UserFacingRole.SUPER_ADMIN]: 'Super Admin',
  [UserFacingRole.ADMIN]: 'Admin',
  [UserFacingRole.VIEWER]: 'Viewer',
  [UserFacingRole.USER]: 'User',
  [UserFacingRole.SUPPLIER]: 'Supplier',
}

/** What the top bar's Help menu offers: live support through Pylon, and the knowledge base. */
export const useHelpActions = () => {
  const userData = useAuthenticatedUser()

  // `user` is read on click: reading it before the session is fully authenticated throws.
  const showLiveSupport = () => {
    const { user, org } = userData
    window.Pylon('setNewIssueCustomFields', {
      user_id: user.id,
      user_email: user.email,
      user_role: PYLON_ROLE_LABELS[getUserFacingRoleFromUserConfig(user)],
      organisation_name: org.name,
      organisation_id: org.organisationId,
      session_url: datadogRum.getSessionReplayLink(),
    })
    window.Pylon('show')
  }

  const openKnowledgeBase = () => {
    window.open(isProductionEnvironment() ? SAME_REGION_PYLON_LOGIN_URL : PYLON_LOGIN_URL, '_blank', 'noopener,noreferrer')
  }

  return { showLiveSupport, openKnowledgeBase }
}
